// employeeAPI.js
import apiClient from '../../../../../../services/apiClient';
import { toast } from 'react-toastify';

export const employeeAPI = {
  // Получить активных сотрудников
  async getActiveEmployees(kindergartenId) {
    try {
      const response = await apiClient.get(`employees/${kindergartenId}/active`);
      return response.data.data || [];
    } catch (error) {
      console.error('Ошибка получения активных сотрудников:', error);
      //toast.error('Не вдалося завантажити список співробітників');
      throw error;
    }
  },

  // Получить уволенных сотрудников
  async getDismissedEmployees(kindergartenId) {
    try {
      const response = await apiClient.get(`employees/${kindergartenId}/dismissed`);
      return response.data.data || [];
    } catch (error) {
      console.error('Ошибка получения уволенных сотрудников:', error);
      //toast.error('Не вдалося завантажити список звільнених співробітників');
      throw error;
    }
  },

  // Получить сотрудника по ID
  async getEmployeeById(kindergartenId, employeeId) {
    try {
      const response = await apiClient.get(`employees/${kindergartenId}/employee/${employeeId}`);
      return response.data.data;
    } catch (error) {
      console.error('Ошибка получения данных сотрудника:', error);
      //toast.error('Не вдалося завантажити дані співробітника');
      throw error;
    }
  },

  // Создать сотрудника
  async createEmployee(kindergartenId, employeeData) {
    try {
      const response = await apiClient.post(`employees/${kindergartenId}`, employeeData);
      //toast.success('Співробітника успішно створено!');
      return response.data.data;
    } catch (error) {
      console.error('Ошибка создания сотрудника:', error);
      //toast.error(error.response?.data?.message || 'Не вдалося створити співробітника');
      throw error;
    }
  },

  // Обновить сотрудника
  async updateEmployee(kindergartenId, employeeId, employeeData) {
    try {
      const response = await apiClient.put(`employees/${kindergartenId}/${employeeId}`, employeeData);
      //toast.success('Дані працівника успішно оновлено!');
      return response.data.data;
    } catch (error) {
      console.error('Ошибка обновления сотрудника:', error);
      //toast.error(error.response?.data?.message || 'Не вдалося оновити співробітника');
      throw error;
    }
  },

  // Уволить сотрудника
  async dismissEmployee(kindergartenId, employeeId) {
    try {
      const response = await apiClient.patch(`employees/${kindergartenId}/${employeeId}/dismiss`);
      //toast.success('Співробітника успішно звільнено!');
      return response.data.data;
    } catch (error) {
      console.error('Ошибка увольнения сотрудника:', error);
      //toast.error('Не вдалося звільнити співробітника');
      throw error;
    }
  },

  // Восстановить сотрудника
  async restoreEmployee(kindergartenId, employeeId) {
    try {
      const response = await apiClient.patch(`employees/${kindergartenId}/${employeeId}/restore`);
      //toast.success('Співробітника успішно поновлено!');
      return response.data.data;
    } catch (error) {
      console.error('Ошибка восстановления сотрудника:', error);
      //toast.error('Не вдалося поновити співробітника');
      throw error;
    }
  },

  // Получить доступные должности
  async getAvailableStaffPositions(kindergartenId) {
    try {
      const response = await apiClient.get(`employees/${kindergartenId}/available-positions`);
      return response.data.data || [];
    } catch (error) {
      console.error('Ошибка получения доступных должностей:', error);
      //toast.error('Не вдалося завантажити список посад');
      throw error;
    }
  },

  // Проверить доступность должности
  async checkPositionAvailability(kindergartenId, { staffPositionId, requiredUnits }) {
    try {
      const response = await apiClient.post(`employees/${kindergartenId}/check-availability`, {
        staffPositionId,
        requiredUnits
      });
      return response.data.data;
    } catch (error) {
      console.error('Ошибка проверки доступности:', error);
      throw error;
    }
  }
};